angular.module('cvsApp').service('getOrderEntryDetailsService',['cvsAppData', 'pznQuestionsModel','configManager','networkService','itemCartModel', function (CAD,PQM,CM,NS,ICM) {

	function getOrderEntryDetailsService (){
		var self = this;
		
		this.getpznQuestionsData = function(callBackSuccess){
			/**
			 * SP 11/07/2016 - ITPR015400 - Guest Refill
			 * Modified to read token and token type from app data
			 */
			var tokenID = CAD.getTokenId();
			var url = CM.getAPIUrlWithOtherInfo('GET_ORDER_ENTRY_DETAILS', tokenID, CAD.getTokenType());
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
							header:{'Content-Type':'application/json'},
							data:getRequestBody(),
							onSuccess:callBackSuccess
						}
			
				cvsUtility.commonServiceCode(url,"getOrderEntryDetailsService",self,request,callBackSuccess,NS);	
			}
		}


		this.setResponse = function(data){
			/*var d = t.replace(/"value"/g, '"y"');*/
			String.prototype.replaceAll = function(search, replacement) {
				var target = this;
				return target.split(search).join(replacement);
			};
			var stringified = JSON.stringify(data);
			stringified = stringified.replaceAll('"clinicalQuestion"', '"clinicalQuestions"');
			stringified = stringified.replaceAll('"answerOption"', '"answerOptions"');
			stringified = stringified.replaceAll('"subQuestion"', '"subQuestions"');
			var jsonObject = JSON.parse(stringified);
			PQM.setResponse(jsonObject);
		}	

		this.getResponse = function(){				
			return PQM.getResponse();		
		}

		var getRequestBody = function(){
			var drugArray = [];
			if(!CAD.getDrugDataList()){
				var dList = ICM.getCartItems();
				for(var i =0; i< dList.length; i++){
					var obj = {"sourceSystem": dList[i].prescriptionSystemName,
						            "rxNumberEnc": dList[i].rxNumberEnc,
						            "drugNdc": dList[i].dispensedDrugNDC
						        }
						drugArray.push(obj);        
				}
			}else{
				drugArray = CAD.getDrugDataList();
			}	

			var requestJson = {"getOrderEntryDetailsRequest": {
			    "standardRequest": {
			      "clientTraceLevel": "1",
			      "tokenID":  CAD.getTokenId(),
       			   "tokenType":  CAD.getTokenType()

			    },
			     "rxInfo": drugArray
			  }
			};
			
			return requestJson;

		};
        this.getpznClinicalQuestions = function(callBackSuccess){
            /**
             * SP 11/07/2016 - ITPR015400 - Guest Refill
             * Modified to read token and token type from app data
             */
            var tokenID = CAD.getTokenId();
            var url = CM.getApiUrlWithApikeyV2('GET_CLINICAL_QUESTIONS', tokenID, CAD.getTokenType());
            if(url === "URL_ERROR"){

            }else{
                var request = {url:url,
                    header:{'Content-Type':'application/json'},
                    data:getClinicalRequestBody(),
                    onSuccess:callBackSuccess
                }

                cvsUtility.commonServiceCode(url,"getClinicalQuestions",self,request,callBackSuccess,NS);
            }
        };
        var getClinicalRequestBody = function(){
            var drugArray = [];
            if(!CAD.getDrugDataList()){
                var dList = ICM.getCartItems();
                for(var i =0; i< dList.length; i++){
                    var obj = {"sourceSystem": dList[i].prescriptionSystemName,
                        "rxNumberEnc": dList[i].rxNumberEnc,
                        "drugNdc": dList[i].dispensedDrugNDC
                    }
                    drugArray.push(obj);
                }
            }else{
                drugArray = CAD.getDrugDataList();
            }

            var requestJson = {"getClinicalQuestionsRequest": {
                "header": {
                    "serviceContext": {
                        "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                        "lineOfBusiness": "Specialty",
                        "channelName": cvsUtility.queryMap.channel,
                        "tokenID": CAD.getTokenId(),
                        "tokenType": CAD.getTokenType()
                    },
                    "securityContext": {"apiKey": CAD.getApiKey()}
                },
                "details": {
                "standardRequest": {
                    "clientTraceLevel": "1",
                    "tokenID": CAD.getTokenId(),
                    "tokenType": CAD.getTokenType()

                },
                "rxInfo": drugArray
            }
            }
            };

            return requestJson;

        };
	}


	return new getOrderEntryDetailsService();
}]);
